import TorrentsTableContainer from './torrentsTable.container';

export default TorrentsTableContainer;
